export default __webpack_public_path__ + "static/img-mahi-mahi-500x325-94e57da4ea3dcf811ab0436f9e55ac0b.png";